import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const getEntityNameLocoKeyByEntityType = (
  type: EntityTypeEnum | keyof typeof structureTypes,
) => {
  return `entity_settings.${type}.header`.toLowerCase()
}
